// import { PROFESSIONAL_DELIVERY } from '@components/checkout/checkout-parts/delivery-section/delivery-options/constants'

// eslint-disable-next-line
export const AB_TESTS = [
  // {
  //   name: 'checkout_delivery_option',
  //   isActive: true,
  //   optionA: null,
  //   optionB: PROFESSIONAL_DELIVERY,
  //   optionAPercent: 50, // integer value from 0 to 100
  // },
]

// ! The initial A/B Test set up for FD-3077 has been removed but the comments are left here for future reference
/*
  Set isActive to true to turn on A/B testing for FD-3077, which is testing
  the elimination of the default selection for the Delivery step of Checkout.

  This variable is used to set the initial redux value of deliveryMode in src/redux/modules/checkout.js.
  When turned on, the value for deliveryMode will be randomly set to either optionA (null = no option
  selected) or optionB ('delivery' = Premium Delivery selected by default) with the randomness weighted
  according to the optionAPercent value, which specifies the percentage users who will see Option A
  rather than Option B. e.g, optionAPercent = 75 means approximately 75% of users will see Option A
  and 25% of users will see Option B.

  Set isActive to false to revert back to always using Premium Delivery as default
  pre-selected option when going to the Delivery step of Checkout

  Once A/B testing is completed, clean-up by:
  1. Delete the corresponding test object from the AB_TESTS array in this file
  2. In src/redux/modules/checkout.js:
      - Remove the imports from this file and the if() statement that sets the value of initialDeliveryMode.
      - Set the value of initialDeliveryMode to the desired result of the A/B Test: null for no default
        or PROFESSIONAL_DELIVERY for Premium Delivery selected by default
      - Remove the abTesting field from initialState
  3. In src/redux/modules/global.js, remove the imports from this file and the associated abTest logic
  4. Clean up the GA setup for the test that was added in src/lib/helpers/google-tag-manager.js
*/
